<template>
<div>
    <!-- input text 유형 -->
    <div class="pl-4 mb-2 d-flex align-items-center" v-if="type=='input_text'">
        <div class="pr-2"> {{ structure.pre_text }} </div>
        <b-input-group style="width:70%; max-width:80%;">
            <b-form-input :disabled="disabled" v-model="result" @update="handleUpdate" :placeholder="structure.placeholder" ></b-form-input>
            <b-input-group-append><b-button :disabled="disabled" class="f-80" variant="icon-append" v-b-modal="`input-text-${code}`"><fa icon="pen"></fa></b-button></b-input-group-append>
        </b-input-group>
        <div class="pl-2"> {{ structure.after_text }} </div>

        <b-modal @ok="handleOK" size="lg" :id="`input-text-${code}`" :title="structure.placeholder" >
            <p class="mb-2 f-90 gray-600"> 상세설명을 작성하여 주십시오.</p>
                <b-textarea :disabled="disabled" v-model="result" rows="5"></b-textarea>
        </b-modal>
    </div>

    <!-- input number 유형  -->
    <div class="pl-4 mb-2 d-flex align-items-center" v-else-if="type=='input_number'">
        <div class="pr-2"> {{ structure.pre_text }} </div>
            <b-form-input style="max-width:50%;" :disabled="disabled" v-model="result" @update="handleUpdate" :placeholder="structure.placeholder" type='number'></b-form-input>
        <div class="pl-2"> {{ structure.after_text }} </div>
    </div>

    <!-- checkbox 유형 -->
    <div class="pl-4 mb-2 d-flex align-items-center" v-else-if="type=='checkbox'">
            <b-form-checkbox-group v-model="result" @change="handleUpdate" stacked>
                <b-row v-for="(checkbox_option, index) in structure" :key="checkbox_option.id" class="ml-2">
                    <b-col class="col-12 mb-1" >
                        <b-form-checkbox
                        :value="checkbox_option.value" :class="isIE==true?'element-check':'hannah'"
                        :disabled="disabled" 
                        > <span v-html="checkbox_option.text"></span> </b-form-checkbox>
                    </b-col>
                    <b-col cols="12" class="mb-2 ml-4 w-100">
                        <b-input-group v-if="checkbox_option.description != undefined">
                            <b-form-input
                                v-model="checkbox_option.description"
                                :disabled="!result.includes(checkbox_option.value) || disabled"
                                :placeholder="checkbox_option.placeholder ? checkbox_option.placeholder : '상세설명'"
                                class="f-90"
                                @update="handleUpdate"
                                ></b-form-input>
                            <b-input-group-append><b-button :disabled="!result.includes(checkbox_option.value) || disabled" v-b-modal="`checkbox-text-${code}-${index}`" size="sm" variant="icon-append"><fa icon="pen"></fa></b-button></b-input-group-append>
                            <b-modal @ok="handleOK" :id="`checkbox-text-${code}-${index}`" :title="checkbox_option.value ? checkbox_option.value : $t(`텍스트 상세입력`)" size="lg">
                                <div>
                                    <p class="mb-2 pl-1 f-90"> {{$t(`상세설명을 작성하여 주십시오.`)}}</p>
                                    <b-textarea rows="5" v-model="checkbox_option.description"></b-textarea>
                                </div>
                            </b-modal>
                        </b-input-group>
                    </b-col>
                </b-row>
            </b-form-checkbox-group>
    </div>

</div>
</template>
<script>
export default {
    data(){
        return {
            type: '',
            result: [],
            structure: [],
            code: Math.random() * 100000,

            //type: 'input_text', // input_number, input_text
            //result: '',
            //structure: [{
                //pre_text: '시험삼아',
                //after_text: '해보았습니다',
                //placeholder: '입력'
            //}]

            //type: 'checkbox', // checkbox
            //result: [],
            //structure: [
            //     {
            ///         "text": "이사회 의장이 독립이사임", 
            //          "value": "이사회 의장이 독립이사", 
            //          "description": ""
            //      }, 
            //      {
            //          "text": "이사회 의장이 전 CEO 또는 전 의장임", 
            //          "value": "이사회 의장이 전 CEO 또는 전 의장", 
            //          "description": ""
            //      }, 
            //      {
            //          "text": "이사회 의장이 기타비상무이사임", 
            //          "value": "이사회 의장이 기타비상무이사", 
            //          "description": ""
            //      }, 
            //      {
            //          "text": "이사회 의장이 CEO 또는 사내이사임", 
            //          "value": "이사회 의장이 CEO 또는 사내이사", 
            //          "description": ""
            //      }
            //  ]
        }

    },
    props:{
        item_idx: { type: Number},
        element_idx: { type: Number},
        element_item: { type: Object },
        disabled: { type: Boolean },
        audit_mode: { type: Boolean }
    },
    computed:{
        isIE() {
            let agent = navigator.userAgent.toLowerCase()
            if ( (navigator.appName == 'Netscape' && navigator.userAgent.search('Trident') != -1) || (agent.indexOf("msie") != -1) )
                {
                    return true
                }
            else
                { 
                    return false
                }
        }
    },
    methods:{
        handleUpdate(){
            Vue.nextTick( () => {
                console.log('input-event-emmit')
                let new_element_item = {
                    type: this.type, 
                    result: this.result,
                    structure: this.structure
                }
                console.log(new_element_item)
                this.$emit('change', this.item_idx, this.element_idx, new_element_item)
            })
        },
        handleOK(){
            if(this.result.length==0) bvModalEvt.preventDefault()
            this.handleUpdate()
        },
    },
    created(){
        this.type = this.element_item.type
        this.result = this.element_item.result
        this.structure = this.element_item.structure
        console.log(this.isIE)
    }
}
</script>
<style>
.element-check > label,
.element-check > label > span{
    min-width: 450px;
}
</style>